import axios from '@dap/shared-utils/http.js';

export default {
    getSearchConnectionData (params = {}) {
        return axios.get('/dapper/api/aud/fb/search_connection', { params });
    },

    getFbDictData (params = {}) {
        return axios.get('/dapper/api/aud/fb_dict', { params });
    },

    getAudData (params = {}) {
        return axios.get('/dapper/api/cro/crowds', { params });
    },

    getLanguageData (params = {}) {
        return axios.get('/dapper/api/aud/fb/ad_locale', { params });
    },

    saveData (params = {}) {
        return axios.post('/dapper/api/aud/fb_audiences', params);
    },

    saveEditData (params = {}) {
        return axios.put('/dapper/api/aud/fb_audiences', params);
    },

    getBatchData (params = {}) {
        return axios.get('/dapper/api/aud/fb/bulk_add', { params });
    },

    getRegionsData (params = {}) {
        return axios.get('/dapper/api/aud/fb/country-regions', { params });
    },

    getAudienceEstimate (params) {
        return axios.post('/dapper/api/aud/fb/audience_estimate', params);
    },

    getSearchWordData (params = {}) {
        return axios.get('/dapper/api/aud/fb/search_word', { params });
    },

    getCheckName (params = {}) {
        return axios.get('/dapper/api/aud/check_name', { params });
    },

    getAudienceDetail (params = {}) {
        return axios.get('/dapper/api/aud/fb/audience_copy', { params });
    },

    getAdSetsList (params = {}) {
        return axios.get('/dapper/api/aud/fb/link_adgroup', { params });
    },

    getCombinationDetail (params = {}) {
        return axios.get('/dapper/api/aud/fb/combination_detail', { params });
    },

    getCombinationCopy (params) {
        return axios.get('/dapper/api/aud/fb/combination_copy', { params });
    },

    getAudienceNum (params) {
        return axios.post('/dapper/api/aud/fb/switch_format', params);
    },
};
